module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ui-details"
  }, [(_vm.title) ? _c('ui-headline', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "ui-details-meta"
  }, [_c('section', {
    staticClass: "ui-details-coversection"
  }, [(_vm.cover) ? _c('div', {
    class: ['ui-details-cover', _vm.image ? 'has-image' : ''],
    style: (_vm.coverStyle)
  }) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "ui-details-list"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index,
      class: ['ui-details-list__item', _vm.size, item === 'break' ? 'break' : '']
    }, [(item !== 'break') ? [_c('div', {
      staticClass: "ui-details-list__item__label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "ui-details-list__item__value"
    }, [(Array.isArray(item.value)) ? _vm._l((item.value), function(text) {
      return _c('div', [_vm._v(_vm._s(text))])
    }) : [(item.isLink || item.onClick) ? [_c('ui-link', {
      on: {
        "click": item.onClick
      }
    }, [_vm._v(_vm._s(item.value))])] : [_vm._v("\n                                " + _vm._s(item.value) + "\n                            ")]]], 2)] : _vm._e()], 2)
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348ae1c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/universal/UiDetails.vue
// module id = 437
// module chunks = 1